<!-- src/views/user/index.vue -->
<template>
	<div class="app-body">
		<div class="a-flex-rsbc a-ptb-6">
			<span class="a-fs-16">用户列表</span>
			<!-- <el-button icon="el-icon-upload2" class="s-btn-exp">导出</el-button> -->
		</div>

		<el-card class="el-main">
			<le-search-form id="leSearch" @reset="handlerRest" @search="handlerSearch">
				<le-input label="名称" v-model="pageParam.params.nameKeyword" placeholder="请输入姓名" />
				<le-input label="手机" v-model="pageParam.params.phone" placeholder="请输入手机号" />
				<le-input label="单位名称" v-model="pageParam.params.companyNameKeyword" placeholder="请输入单位名称" />
				<le-input-district-choose label="单位地区" :province.sync="pageParam.params.provinceCode" :city.sync="pageParam.params.cityCode" :area.sync="pageParam.params.districtCode"></le-input-district-choose>
				<le-date-range 
					label="注册日期" 
					:minDate.sync="pageParam.params.startTime" 
					:maxDate.sync="pageParam.params.endTime" 
					:defaultTime="['00:00:00','23:59:59']"
					valueFormat="yyyy-MM-dd HH:mm:ss" />
			</le-search-form>
			
			<le-pagview @setData="setTableData" :pageParam="pageParam" :total.sync="total" ref="userPage" :isFixed="true" :tableRef="$refs.userList">
				<el-table :data="tableData" :highlight-current-row="true" ref="userList" v-sticky="{ top: 0, parent:'.el-card__body' }">
					<!-- 用户名称 -->
					<el-table-column prop="userName" label="名称" width="100" >
						<template slot-scope="{ row }">
							<span>{{ row.userName || '-' }}</span>
						</template>
					</el-table-column>

					<!-- 手机号 -->
					<el-table-column prop="phone" label="手机号" width="150" >
						<template slot-scope="{ row }">
							<span>{{ row.phone || '-' }}</span>
						</template>
					</el-table-column>

					<!-- 单位 -->
					<el-table-column prop="companyName" label="单位" width="150" >
						<template slot-scope="{ row }">
							<span>{{ row.companyName || '-' }}</span>
						</template>
					</el-table-column>

					<!-- 部门 -->
					<el-table-column prop="department" label="部门" width="100" >
						<template slot-scope="{ row }">
							<span>{{ row.department || '-' }}</span>
						</template>
					</el-table-column>

					<!-- 职位 -->
					<el-table-column prop="position" label="职位" width="100" >
						<template slot-scope="{ row }">
							<span>{{ row.position || '-' }}</span>
						</template>
					</el-table-column>

					<!-- 单位区域 -->
					<el-table-column prop="unitArea" label="单位区域" width="180" >
						<template slot-scope="{ row }">
							<span>{{ row.provinceName || '-' }}{{ row.cityName || '-' }}{{ row.districtName || '-' }}</span>
						</template>
					</el-table-column>

					<!-- 单位地址 -->
					<el-table-column prop="address" label="单位地址" width="200" >
						<template slot-scope="{ row }">
							<span>{{ row.address || '-' }}</span>
						</template>
					</el-table-column>

					<!-- 邮箱 -->
					<el-table-column prop="email" label="邮箱" width="150" >
						<template slot-scope="{ row }">
							<span>{{ row.email || '-' }}</span>
						</template>
					</el-table-column>

					<!-- 介绍 -->
					<el-table-column prop="introduction" label="介绍" width="200" >
                        <template slot-scope="{ row }">
                            <div class="a-flex-rfsc">
                                <el-tooltip placement="top">
                                    <div slot="content" style="width: 400px;">{{ row.introduction }}</div>
                                    <span style="width: 200px;" class="textOver1">{{ row.introduction }}</span>
                                </el-tooltip>
                            </div>
                        </template>
					</el-table-column>

					<!-- 注册时间 -->
					<el-table-column prop="createTime" label="注册时间" width="180" >
						<template slot-scope="{ row }">
							<span>{{ row.createTime || '-' }}</span>
						</template>
					</el-table-column>

					<!-- 需求/供应/意向 -->
					<el-table-column prop="demandSupplyIntent" label="需求/供应/意向" width="150" >
						<template slot-scope="{ row }">
							<span>{{ row.demandCount }}/{{ row.supplyCount }}/{{ row.intentionCount }}</span>
						</template>
					</el-table-column>

					<!-- 操作 -->
					<!-- <el-table-column label="操作" width="80" fixed="right" >
						<template slot-scope="{ row }">
							<el-button type="text" @click="handleEdit(row)">权限编辑</el-button>
						</template>
					</el-table-column> -->
				</el-table>
                <template slot="footerContent" slot-scope="scope" >
                    <div class="a-flex-rfsc">
                        <div class="a-flex-rfsc">
                            <span class="a-fs-12 a-c-normal">资产评估数量：</span>
                            <span class="a-fs-16 a-c-master a-fw-b">{{ total }}</span>
                        </div>
                    </div>
                </template>
			</le-pagview>
		</el-card>

		<!-- 权限控制弹窗 -->
		<el-dialog
			title="权限控制"
			:visible.sync="permissionDialogVisible"
			width="400px"
			@close="handlePermissionClose"
		>
			<el-form
				ref="permissionForm"
				:model="permissionFormData"
				:rules="permissionRules"
				label-width="100px"
			>
				<el-form-item label="发布需求" prop="publishDemand">
					<el-select v-model="permissionFormData.publishDemand" placeholder="请选择">
						<el-option label="开启" value="开启"></el-option>
						<el-option label="关闭" value="关闭"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="发布供应" prop="publishSupply">
					<el-select v-model="permissionFormData.publishSupply" placeholder="请选择">
						<el-option label="开启" value="开启"></el-option>
						<el-option label="关闭" value="关闭"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="合作意向" prop="cooperationIntent">
					<el-select v-model="permissionFormData.cooperationIntent" placeholder="请选择">
						<el-option label="开启" value="开启"></el-option>
						<el-option label="关闭" value="关闭"></el-option>
					</el-select>
				</el-form-item>
			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-button @click="handlePermissionClose">取 消</el-button>
				<el-button type="primary" @click="handlePermissionSubmit">保 存</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import util from "../../utils/util.js";

export default {
	name: 'UserList',
	data() {
		return {
			util: util,
			tableData: [],
			pageParam: {
				url: this.$Config.apiUrl.userPage, 
				method: "post",
				params: {
					nameKeyword: "",
					phone: "",
					companyNameKeyword: "",
					provinceCode: "",
					cityCode: "",
					districtCode: "",
					startTime: "",
					endTime: ""
				},
                freshCtrl: 1
			},
			// 权限控制弹窗状态
			permissionDialogVisible: false,
			// 当前编辑的用户
			currentUser: {},
			// 权限表单数据
			permissionFormData: {
				publishDemand: "开启",
				publishSupply: "开启",
				cooperationIntent: "开启"
			},
			// 权限表单验证规则
			permissionRules: {
				publishDemand: [{ required: true, message: '请选择发布需求权限', trigger: 'change' }],
				publishSupply: [{ required: true, message: '请选择发布供应权限', trigger: 'change' }],
				cooperationIntent: [{ required: true, message: '请选择合作意向权限', trigger: 'change' }]
			},
			// 操作权限选项
			permissionOptions: [
				{ value: '', label: '全部' },
				{ value: '开启', label: '开启' },
				{ value: '关闭', label: '关闭' }
			],
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now();
				}
			},
            total: 0
		};
	},
	mounted() {
		this.pageParam.freshCtrl++; 
	},
	methods: {
		handlerRest() {
			this.pageParam.params = {
				nameKeyword: "",
				phone: "",
				companyNameKeyword: "",
				provinceCode: "",
				cityCode: "",
				districtCode: "",
				startTime: "",
				endTime: ""
			};
			this.handlerSearch()
		},
		handlerSearch() {
			this.$refs['userPage'].pageNum = 1
			this.pageParam.freshCtrl++;
		},
		
		// 设置表格数据
		setTableData(data) {
			this.tableData = data;
		},

		// 编辑用户信息
		handleEdit(row) {
			this.currentUser = row;
			this.permissionDialogVisible = true;
			// 初始化权限表单数据
			this.permissionFormData = {
				publishDemand: row.publishDemand || "开启",
				publishSupply: row.publishSupply || "开启",
				cooperationIntent: row.cooperationIntent || "开启"
			};
		},

		// 关闭权限控制弹窗
		handlePermissionClose() {
			this.permissionDialogVisible = false;
			this.$refs.permissionForm.resetFields();
		},

		// 提交权限设置
		handlePermissionSubmit() {
			this.$refs.permissionForm.validate((valid) => {
				if (valid) {
					// 这里调用后端接口保存权限设置
					// api.updateUserPermission(this.currentUser.id, this.permissionFormData).then(() => {
					//   this.$message.success('权限设置成功');
					//   // 更新表格中的权限状态
					//   const index = this.tableData.findIndex(item => item.id === this.currentUser.id);
					//   if (index !== -1) {
					//     this.tableData[index].publishDemand = this.permissionFormData.publishDemand;
					//     this.tableData[index].publishSupply = this.permissionFormData.publishSupply;
					//     this.tableData[index].cooperationIntent = this.permissionFormData.cooperationIntent;
					//   }
					// });
					this.handlePermissionClose();
				} else {
					return false;
				}
			});
		}
	}
};
</script>

<style scoped lang="scss">
.status-tag {
	padding: 2px 8px;
	border-radius: 4px;
	font-size: 12px;
}

.status-tag.active {
	background-color: #f0f9eb;
	color: #67c23a;
}

.status-tag.disabled {
	background-color: #f5f5f5;
	color: #999;
}

.el-button--mini {
	padding: 4px 8px;
	font-size: 12px;
}

/* 操作按钮间距 */
.el-button + .el-button {
	margin-left: 8px;
}
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
    /*width: 0;宽度为0隐藏*/
    width: 0 !important;
    height: 0 !important;
}
/deep/ .el-table__fixed, /deep/ .el-table__fixed-right{
    height: 100% !important;
}
</style>